export default __webpack_public_path__ + "static/media/image3.d816f5da.jpg";